import React, { useEffect, useState, FC, useMemo } from 'react';
import { zeroPad } from '../../helpers/functionHelpers/functionHelpers';
import TestIds from '../../tests/TestIds';
import styles from './Countdown.module.scss';

interface Props {
	endDate: string;
	timeExpiredCallback?: () => void;
}

const Countdown: FC<Props> = ({ endDate, timeExpiredCallback }) => {
	const [time, setTime] = useState(new Date().getTime());
	const difference = useMemo(() => new Date(endDate).getTime() - time, [endDate, time]);

	const timeLeft = useMemo(() => {
		const state = {
			hours: 0,
			minutes: 0,
			seconds: 0,
		};

		if (difference > 0) {
			state.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
			state.minutes = Math.floor((difference / 1000 / 60) % 60);
			state.seconds = Math.floor((difference / 1000) % 60);
		}
		return state;
	}, [difference]);

	useEffect(() => {
		const timer = setInterval(() => setTime(new Date().getTime()), 1000);
		return () => clearInterval(timer);
	}, []);

	useEffect(() => {
		const timer = setInterval(() => {
			if (difference <= 0 && typeof timeExpiredCallback === 'function') timeExpiredCallback();
		}, 1000);
		return () => clearInterval(timer);
	}, [difference, timeExpiredCallback]);

	const { hours, minutes, seconds } = timeLeft;
	return hours > 0 ? (
		<span data-cy={TestIds.Countdown} className={styles.value}>{`${zeroPad(hours)}h ${zeroPad(
			minutes
		)}m`}</span>
	) : (
		<span data-cy={TestIds.Countdown} className={styles.value}>{`${zeroPad(minutes)}:${zeroPad(
			seconds
		)}`}</span>
	);
};

export default Countdown;
